var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"dashboard-footer text-center"},[_vm._v(" © Copyright 2021 - Active Intro ")])])}]

export { render, staticRenderFns }